
// eslint-disable-next-line import/no-webpack-loader-syntax
// import styles from '!!raw-loader!sass-loader!./MessageHTML.sass'

export function MessageHTML (props) {
  const manipulateHtmlResulted = (el) => {
    if (el) {
      el.querySelectorAll('a').forEach((button) => {
        if (button) button.setAttribute('target', '_blank')
      })
    }
  }
  return <>
    <content-html dangerouslySetInnerHTML={{ __html: props.html }} ref={manipulateHtmlResulted}/>
    <style rel="stylesheet" type="text/css">{`
      @viewport {
        width: device-width
      }
      content-html {
        display: block;
        overflow-wrap: anywhere;
        object-fit: contain
        font-size: 20px
      }
      content-html img {
        max-width: 100% !important;
        height: auto !important;
      }

      @media (max-width: 640px) {
        content-html table {
          max-width: calc(100vw - 2rem) !important;
          height: auto !important;
        }
      }

    `}</style>
  </>
}
